// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum VehicleRegisterVehicleSearchStatus {
  SearchSuccessful = "SEARCH_SUCCESSFUL",
  OnlineSearchDisabled = "ONLINE_SEARCH_DISABLED",
  OnlineSearchFailed = "ONLINE_SEARCH_FAILED",
}
export default VehicleRegisterVehicleSearchStatus;
